

import {environment} from '../../../environments/environment';
import * as SockJS from 'sockjs-client';
import {AuthService} from '../../auth/auth.service';
export function stompConfigFactory(auth: AuthService) {
  let isDevMode = !environment.production;
  const stompConfig = {
    // Which server?
    url: new SockJS(environment.stompUrl),

    // Headers
    // Typical keys: login, passcode, host
    // How often to heartbeat?
    // Interval in milliseconds, set to 0 to disable
    heartbeat_in: 0, // Typical value 0 - disabled
    headers: {
      Authorization: `Bearer ${ auth.getToken()}`
    },

    heartbeat_out: 20000, // Typical value 20000 - every 20 seconds


    // Wait in milliseconds before attempting auto reconnect
    // Set to 0 to disable
    // Typical value 5000 (5 seconds)
    reconnect_delay: 5000,

    // Will log diagnostics on console
    debug: isDevMode
  }
  return stompConfig;
};




// WEBPACK FOOTER //
// ./src/app/core/stomp/stomp.config.ts